// extracted by mini-css-extract-plugin
export default {"container":"styles_container__J5LLK","header":"styles_header__888n1","form":"styles_form__Bk8-t"};